import $ from "jquery"; // Remove this line if not using jQuery

const TOGGLE_SELECTOR = ".js-nav-search-toggle";
const CLOSE_SELECTOR = ".js-nav-search-close";
const TOGGLE_NAV_LIST_ITEM = ".js-nav-list-item";
const ANIMATION_DURATION = 600;
const SEARCH_FIELD_SELECTOR = "#my-autocomplete-top, #SearchBox-searchAppBox--nav";

const TOGGLED_CLASS = "nav-search-toggled";

const $body = $("body");
const $searchField = $(SEARCH_FIELD_SELECTOR);

function init(): void {
  $(TOGGLE_SELECTOR).attr("aria-expanded", "false");

  $(TOGGLE_SELECTOR).click(function (e) {
    e.preventDefault();
    $(TOGGLE_SELECTOR).blur();

    if ($body.hasClass(TOGGLED_CLASS)) {
      // Blur if this field is currently focused
      $searchField.blur();

      $body.removeClass(TOGGLED_CLASS);
      $(TOGGLE_SELECTOR).attr("aria-expanded", "false");
      $(TOGGLE_NAV_LIST_ITEM).attr("aria-hidden", "false");
    } else {
      $body.addClass(TOGGLED_CLASS);
      $(TOGGLE_SELECTOR).attr("aria-expanded", "true");
      $(TOGGLE_NAV_LIST_ITEM).attr("aria-hidden", "true");

      // Focus on search field when animation is complete
      setTimeout(function () {
        $(SEARCH_FIELD_SELECTOR).trigger('focus');
      }, ANIMATION_DURATION);
    }

    return false;
  });

  $(CLOSE_SELECTOR).click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($body.hasClass(TOGGLED_CLASS)) {
      // Blur if this field is currently focused
      $searchField.blur();

      $body.removeClass(TOGGLED_CLASS);
      $(TOGGLE_SELECTOR).attr("aria-expanded", "false");
      $(TOGGLE_NAV_LIST_ITEM).attr("aria-hidden", "false");
    }
  });
}

export default { init };
